import request from './request';

// 提交举报
// targetType: video=视频 user=用户 comment=评论
export function submitReport({ targetType, targetId, reason, content, images, contact }) {
  return request.post('/api/report/submit', {
    target_type: targetType,
    target_id: targetId,
    reason: reason,
    content: content || '',
    images: images || '',
    contact: contact || ''
  });
}
